module.exports = __webpack_public_path__ + "img/80.7.Chla.9585ccae.png";